/**
 * TradeEnrichmentPanel.js — Vendor Portal enrichment (tools required + material
 * staging hint + payout SLA countdown).
 */
import React, { useEffect, useState } from "react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const CYAN = "#00CFCF"; const CHROME = "#A0A0A0"; const INK = "#F5F5F7";

const card = { background: "rgba(255,255,255,0.03)", border: `1px solid ${CHROME}33`, borderRadius: 12, padding: "clamp(14px,2.5vw,22px)", marginBottom: 16 };
const chip = { display: "inline-block", padding: "4px 10px", borderRadius: 999, border: `1px solid ${CYAN}66`, color: INK, fontSize: 11, letterSpacing: "0.05em", marginRight: 6, marginBottom: 6, background: "rgba(0,207,207,0.06)" };

export default function TradeEnrichmentPanel({ workOrderId }) {
  const [enrich, setEnrich] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!workOrderId) return;
    fetch(`${BACKEND_URL}/api/role-dashboard/trade/${workOrderId}`)
      .then(r => r.ok ? r.json() : Promise.reject("not enriched"))
      .then(setEnrich).catch(e => setError(String(e)));
  }, [workOrderId]);

  if (error) return null;
  if (!enrich) return null;

  return (
    <div style={card} data-testid="trade-enrichment-panel">
      <div style={{ fontSize: 11, letterSpacing: "0.2em", color: CYAN, marginBottom: 8 }}>
        WORK ORDER DETAILS
      </div>
      <div style={{ marginBottom: 12 }}>
        <div style={{ fontSize: 11, color: CHROME, letterSpacing: "0.15em", marginBottom: 6 }}>TOOLS REQUIRED</div>
        {(enrich.tools_required || []).map((t, i) => <span key={i} style={chip} data-testid={`trade-tool-${i}`}>{t}</span>)}
      </div>
      <div style={{ marginBottom: 12 }}>
        <div style={{ fontSize: 11, color: CHROME, letterSpacing: "0.15em", marginBottom: 6 }}>MATERIAL STAGING</div>
        <div style={{ fontSize: 13 }} data-testid="trade-staging-hint">
          <strong>Zone:</strong> {enrich.material_staging_hint?.zone || "TBD"} — {enrich.material_staging_hint?.staging_instruction}
        </div>
      </div>
      <div style={{ marginBottom: 8 }}>
        <div style={{ fontSize: 11, color: CHROME, letterSpacing: "0.15em", marginBottom: 6 }}>PAYOUT SLA</div>
        <div style={{ fontSize: 13, color: CYAN }} data-testid="trade-payout-sla">
          {enrich.payout_sla_hours}-hour rapid payout on award · fair-labor baseline · zero markup padding
        </div>
      </div>
      <div style={{ fontSize: 11, color: CHROME, marginTop: 10, fontStyle: "italic" }} data-testid="trade-coo-note">
        {enrich.coo_note}
      </div>
    </div>
  );
}
